import AppsIcon from "@material-ui/icons/Apps";
import { ListItemIcon, ListItemText, Stack } from "@mui/material";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import * as React from "react";

export default function BasicMenu(props: any) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  if (props.type === "bandobast") {
    const data = props.data;
    const toStore = { id: data.id, serialNo: data.serialNo, name: data.name };
    localStorage.setItem("bandobast", JSON.stringify(toStore));
  }

  if (props.type === "timeslot") {
    const data = props.data;
    const toStore = { id: data.id, name: data.name };
    localStorage.setItem("timeslot", JSON.stringify(toStore));
  }

  if (props.type === "location") {
    const data = props.data;
    const toStore = {
      id: data.key,
      name: data.name,
      kind: data.kind,
    };
    localStorage.setItem("location", JSON.stringify(toStore));
  }

  const navigationItems = props.options.filter((e: any) => {
    return e.length < 5 || e[4] === "navigate";
  });

  const actionItems = props.options.filter((e: any) => {
    return e.length >= 5 && e[4] === "action";
  });

  return (
    <div>
      <Button
        variant="outlined"
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        startIcon={<AppsIcon />}
      >
        {props.action}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {navigationItems.map((e: any, index: number) => {
          const text = e[0];
          const onClickHandler = e[1];
          const icon = e[2];
          const itemId = e[3];
          return (
            <MenuItem onClick={handleClose} id={text} key={index}>
              <ListItemIcon>{icon}</ListItemIcon>
              <ListItemText id={itemId} onClick={onClickHandler}>
                {text}
              </ListItemText>
            </MenuItem>
          );
        })}

        {navigationItems.length > 0 && actionItems.length > 0 && <Divider />}

        {actionItems.map((e: any, index: number) => {
          return <div key={index}>{e[1]}</div>;
        })}
      </Menu>
    </div>
  );
}
